
const statusData = [
  { name: "En cours de création", id: "creation", color: "#849191" },
  { name: "En attente", id: "pending", color: "#E3A322" },
  { name: "En cours de souscription", id: "subscribe", color: "#849191" },
  { name: "En cours", id: "inprogress", color: "#008083" },
  { name: "Fini", id: "finished", color: "#91C73C" },
];

const energyData = [
  { name: "Electricité", id: "electricity" },
  { name: "Gaz", id: "gas" },
  { name: "Eau", id: "water" },
  { name: "Chaleur", id: "heat" },
  { name: "Froid", id: "cold" },
  { name: "Propane", id: "propane" },
  { name: "Fioul", id: "fuel" },
  { name: "Bois", id: "wood" },
];

const membershipStatusData = [
  { name: "Non adhérent", id: "notmember", color: "#008083" },
  { name: "Demande envoyée", id: "requestsent", color: "#3E8FC6" },
  { name: "En cours de traitement", id: "requestpending", color: "#3E8FC6" },
  { name: "Demande refusée", id: "requestrefused", color: "#C53F3F" },
  { name: "Adhérent", id: "member", color: "#91C73C" },
  { name: "En cours de sortie", id: "endinprogress", color: "#C53F3F" },
  { name: "Ancien adhérent", id: "oldmember", color: "#008083" },
];

const metersStatusData = [
  { name: "Dans le marché", id: "in", color: "#91C73C" },
  { name: "Hors du marché", id: "pending", color: "#C53F3F" },
];

const membershipStatusDataNoAdmin = [
  { name: "En cours de sortie", id: "endinprogress", color: "#C53F3F" },
];

const mandateStatusDataSelect = [
  { name: "En cours de signature", id: "signature", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Validé", id: "accepted", color: "#91C73C" },
  { name: "Non valide", id: "refused", color: "#C53F3F" },
];

const mandateStatusDataSelectNoAdmin = [
  { name: "En cours de signature", id: "signature", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
];

const mandateStatusDataTab = [
  { name: "En cours de signature", id: "signature", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Valide", id: "accepted", color: "#91C73C" },
  { name: "Non valide", id: "refused", color: "#C53F3F" },
  { name: "Valide", id: "okandbefore", color: "#008083" },
  { name: "Expiré", id: "okandafter", color: "#C53F3F" },
];

const membercontractStatusDataSelect = [
  { name: "En cours de signature", id: "signature", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Validé", id: "accepted", color: "#91C73C" },
  { name: "Non valide", id: "refused", color: "#C53F3F" },
];

const membercontractStatusDataSelectNoAdmin = [
  { name: "En cours de signature", id: "signature", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
];

const membercontractStatusDataTab = [
  { name: "En cours de signature", id: "signature", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Valide", id: "accepted", color: "#91C73C" },
  { name: "Non valide", id: "refused", color: "#C53F3F" },
  { name: "Valide", id: "okandbefore", color: "#008083" },
  { name: "Expiré", id: "okandafter", color: "#C53F3F" },
];

const marketcontractStatusDataSelect = [
  { name: "En cours de signature", id: "signature", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Validé", id: "accepted", color: "#91C73C" },
  { name: "Non valide", id: "refused", color: "#C53F3F" },
];

const marketcontractStatusDataTab = [
  { name: "En cours de signature", id: "signature", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Valide", id: "accepted", color: "#91C73C" },
  { name: "Non valide", id: "refused", color: "#C53F3F" },
  { name: "Valide", id: "okandbefore", color: "#008083" },
  { name: "Expiré", id: "okandafter", color: "#C53F3F" },
];

const memberorderTypeData = [
  { name: "Rattachement", id: "attachmeter"},
  { name: "Branchement provisoire", id: "provis" },
  { name: "Détachement", id: "detach"},
  { name: "Modification contractuelle", id: "change"},
];

const memberorderStatusData = [
  { name: "A valider par l'adhérent", id: "membervalidation", color: "#C53F3F"},
  { name: "A valider par le responsable de marché", id: "sent" , color: "#008083" },
  { name: "Soumis", id: "validated", color: "#3E8FC6"},
  { name: "Executé", id: "executed", color: "#91C73C"},
];
const memberorderStatusDataAdmin = [
  { name: "A valider par l'adhérent", id: "membervalidation", color: "#C53F3F"},
  { name: "A valider par le responsable de marché", id: "sent" , color: "#008083" },
  { name: "Executé", id: "executed", color: "#91C73C"},
];

const memberorderElectricitySegment = [
  { name: "C5 (< 36 kVA) - Bâtiment ou autre équipement", id: "C5bat"},
  { name: "C5 (< 36 kVA) - Eclairage public ou assimilé", id: "C5ecl"},
  { name: "C4 (> 36 kVA raccordé en Base Tension)", id: "C4"},
  //{ name: "C3 (> 36 kVA raccordé en Haute Tension - HTA site profilé)", id: "C3"},
  { name: "C2 (> 36 kVA raccordé en Haute Tension - HTA site télérelevé)", id: "C2"},
];

const memberorderElectricityTurpeVersionC5Ecl = [
  { name: "Longue utilisation", id: "lu"},
];
const memberorderElectricityTurpeVersionC5 = [
  { name: "Courte utilisation", id: "cu"},
  { name: "Moyenne utilisation", id: "mu"},
  { name: "Longue utilisation", id: "lu"},
];
const memberorderElectricityTurpeVersionC4C3C2 = [
  { name: "Courte utilisation", id: "cu"},
  { name: "Longue utilisation", id: "lu"},
];
const memberorderElectricityEclHourCount = [
  { name: "2350h (forfait de nuit)", id: "night"},
  { name: "4100h (forfait nocturne)", id: "nocturne"},
  { name: "8760h (forfait permanent)", id: "all"},
];
const memberorderElectricityRenewableMix = [
  { name: "Mix énergetique national", id: "national"},
  //{ name: "30% renouvelable", id: "30"},
  { name: "100% renouvelable", id: "100"},
];
const memberorderGasProfil = [
  { name: "P011", id: "P011"},
  { name: "P012", id: "P012"},
  { name: "P013", id: "P013"},
  { name: "P014", id: "P014"},
  { name: "P015", id: "P015"},
  { name: "P016", id: "P016"},
  { name: "P017", id: "P017"},
  { name: "P018", id: "P018"},
  { name: "P019", id: "P019"},
];
const memberorderGasTariff = [
  { name: "T1 (<6MWh)", id: "T1"},
  { name: "T2 (>6MWh et <300MWh)", id: "T2"},
  { name: "T3 (>300MWh et <5000MWh)", id: "T3"},
  { name: "T4 (>5000MWh)", id: "T4"},
];

const memberclaimStatusData = [
  { name: "A valider par l'adhérent", id: "membervalidation", color: "#C53F3F"},
  { name: "Soumise au responsable de marché", id: "submited" , color: "#008083" },
  { name: "Validée par le responsable de marché", id: "validated", color: "#3E8FC6"},
  { name: "Envoyée au titulaire du marché", id: "sent", color: "#3E8FC6"},
  { name: "Validée par le titulaire du marché", id: "ownervalidated", color: "#91C73C"},
  { name: "Indemnisée", id: "payed", color: "#91C73C"},
  { name: "Refusée", id: "refused", color: "#C53F3F"},
];

const memberclaimStatusDataAdmin = [
  { name: "Soumise au responsable de marché", id: "submited" , color: "#008083" },
  { name: "Validée par le responsable de marché", id: "validated", color: "#3E8FC6"},
  { name: "Envoyée au titulaire du marché", id: "sent", color: "#3E8FC6"},
  { name: "Validée par le titulaire du marché", id: "ownervalidated", color: "#91C73C"},
  { name: "Indemnisée", id: "payed", color: "#91C73C"},
  { name: "Refusée", id: "refused", color: "#C53F3F"},
];

export { statusData, energyData, membershipStatusData,membershipStatusDataNoAdmin, metersStatusData,mandateStatusDataSelect,
  mandateStatusDataTab, mandateStatusDataSelectNoAdmin, membercontractStatusDataSelect, membercontractStatusDataSelectNoAdmin,
  membercontractStatusDataTab, marketcontractStatusDataSelect, marketcontractStatusDataTab, memberorderTypeData, memberorderStatusData,
  memberorderStatusDataAdmin,memberorderElectricitySegment, memberorderElectricityTurpeVersionC5, memberorderElectricityTurpeVersionC4C3C2,
  memberorderElectricityTurpeVersionC5Ecl,memberorderElectricityEclHourCount, memberorderElectricityRenewableMix,memberorderGasProfil,memberorderGasTariff,
  memberclaimStatusData,memberclaimStatusDataAdmin
};
